import { panoramaClient } from './panorama'

panoramaClient.reportLoadStart()

export const monitoring = {
  appLoaded: () => panoramaClient.reportLoadFinish(),
  interactionStarted: (name: string) => panoramaClient.transaction(name).start(),
  interactionEnded: (name: string) => panoramaClient.transaction(name).finish(),
}
